// Booking Page
export const GET_TIMESLOTS_REQUEST = 'GET_TIMESLOTS_REQUEST';
export const GET_TIMESLOTS_SUCCESS = 'GET_TIMESLOTS_SUCCESS';
export const GET_TIMESLOTS_ERROR = 'GET_TIMESLOTS_ERROR';

export const GET_MEALS_REQUEST = 'GET_MEALS_REQUEST';
export const GET_MEALS_SUCCESS = 'GET_MEALS_SUCCESS';
export const GET_MEALS_ERROR = 'GET_MEALS_ERROR';

export const GET_DRINKS_REQUEST = 'GET_DRINKS_REQUEST';
export const GET_DRINKS_SUCCESS = 'GET_DRINKS_SUCCESS';
export const GET_DRINKS_ERROR = 'GET_DRINKS_ERROR';

export const RESET_BOOKING_META = 'RESET_BOOKING_META';
export const RESET_BOOKING_PAGE = 'RESET_BOOKING_PAGE';

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_ERROR = 'CREATE_ORDER_ERROR';

// Receipt Page
export const GET_ORDER_BY_ORDER_ID_REQUEST = 'GET_ORDER_BY_ORDER_ID_REQUEST';
export const GET_ORDER_BY_ORDER_ID_SUCCESS = 'GET_ORDER_BY_ORDER_ID_SUCCESS';
export const GET_ORDER_BY_ORDER_ID_ERROR = 'GET_ORDER_BY_ORDER_ID_ERROR';
export const RESET_RECEIPT_PAGE = 'RESET_RECEIPT_PAGE';

// Payment Callback Page
export const VERIFY_PAYMENT_CALLBACK_REQUEST = 'VERIFY_PAYMENT_CALLBACK_REQUEST';
export const VERIFY_PAYMENT_CALLBACK_SUCCESS = 'VERIFY_PAYMENT_CALLBACK_SUCCESS';
export const VERIFY_PAYMENT_CALLBACK_ERROR = 'VERIFY_PAYMENT_CALLBACK_ERROR';
export const RESET_PAYMENT_CALLBACK_PAGE = 'RESET_PAYMENT_CALLBACK_PAGE';

// Meal Customizations
export const GET_MEAL_CUSTOMIZATIONS_REQUEST = 'GET_MEAL_CUSTOMIZATIONS_REQUEST';
export const GET_MEAL_CUSTOMIZATIONS_ERROR = 'GET_MEAL_CUSTOMIZATIONS_ERROR';
export const GET_MEAL_CUSTOMIZATIONS_SUCCESS = 'GET_MEAL_CUSTOMIZATIONS_SUCCESS';

// Drink Customizations
export const GET_DRINK_CUSTOMIZATIONS_REQUEST = 'GET_DRINK_CUSTOMIZATIONS_REQUEST';
export const GET_DRINK_CUSTOMIZATIONS_ERROR = 'GET_DRINK_CUSTOMIZATIONS_ERROR';
export const GET_DRINK_CUSTOMIZATIONS_SUCCESS = 'GET_DRINK_CUSTOMIZATIONS_SUCCESS';
export const CLEAR_MEAL_CUSTOMIZATIONS = 'CLEAR_MEAL_CUSTOMIZATIONS';
export const CLEAR_DRINK_CUSTOMIZATIONS = 'CLEAR_DRINK_CUSTOMIZATIONS';